"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderReferralList = void 0;
var ProviderReferralList_1 = require("./ProviderReferralList");
Object.defineProperty(exports, "ProviderReferralList", { enumerable: true, get: function () { return __importDefault(ProviderReferralList_1).default; } });
//# sourceMappingURL=index.js.map